import {
  PANEL_LABEL, showing, toggle, DEFAULT_LAYOUT,
  type Layout, type PanelId,
} from '../insights-layout';
import { useEscapeToClose } from '../motion';

/**
 * CHOOSING WHAT INSIGHTS SHOWS — #269, slimmed for Style B (the uniform snap grid).
 *
 * This is the compact "Show panels" popover, opened by its own button in the
 * arrange bar and anchored under it. It is purely the show/hide checklist: order
 * and size live on the screen itself — you drag a card to a new cell and drag its
 * corner to resize — so there are no arrows and no second column. Keeping it as one
 * clean list of checkboxes plus a reset is the shape Vinnie approved.
 *
 * It no longer carries a hint about dragging: arranging now happens on the grid, in
 * plain view, not from inside this list, so a line telling you to drag would point
 * at the wrong place. The popover closes on a click away or Escape (useEscapeToClose)
 * without ending arrange mode — that stays on until "Done arranging".
 */
export default function Arrange({
  layout,
  onChange,
  onClose,
}: {
  layout: Layout;
  onChange: (l: Layout) => void;
  onClose: () => void;
}) {
  useEscapeToClose(onClose);

  return (
    <div className="arrange" role="dialog" aria-label="Show panels">
      <div className="arr-head">
        <span>Show panels</span>
      </div>
      <ul className="arr-list">
        {layout.order.map((id: PanelId) => (
          <li key={id} className={`arr-row ${showing(layout, id) ? '' : 'is-off'}`}>
            <label className="arr-check">
              <input
                type="checkbox"
                checked={showing(layout, id)}
                onChange={() => onChange(toggle(layout, id))}
              />
              <span className="arr-name">{PANEL_LABEL[id]}</span>
            </label>
          </li>
        ))}
      </ul>
      <div className="arr-foot">
        <button className="btn btn-small arr-reset" onClick={() => onChange(DEFAULT_LAYOUT)}>
          Put everything back
        </button>
      </div>
    </div>
  );
}
